import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useSettingStore = defineStore(
    'settingStore',
    () => {
        //Canned Responses
        const allCannedResponses = ref([]);
        const getCannedResponse = computed(() => allCannedResponses.value);
        const setCannedResponse = (value) => {
            allCannedResponses.value = value;
        };
        
        const activeCannedResponse = ref([]);
        const getActiveCannedResponse = computed(() => activeCannedResponse.value);
        const setActiveCannedResponse = (value) => {
            activeCannedResponse.value = value;
        };
        
        const newResponseDetail = ref({
            title: '',
            available_for: 'everyone',
            detail_info: ''
        });
        const getNewCannedResponse = computed(() => newResponseDetail.value);
        const setNewCannedResponse = (value) => {
            newResponseDetail.value = value;
        };

        const editCannedResponse = ref([]);
        const getEditCannedResponse = computed(() => editCannedResponse.value);
        const setEditCannedResponse = (value) => {
            editCannedResponse.value = value;
        };

        return {
            allCannedResponses,
            getCannedResponse,
            setCannedResponse,
            activeCannedResponse,
            getActiveCannedResponse,
            setActiveCannedResponse,
            newResponseDetail,
            getNewCannedResponse,
            setNewCannedResponse,
            editCannedResponse,
            getEditCannedResponse,
            setEditCannedResponse
        };
    },
    {
        persist: true,
    }
);
